module.exports = "Par <%=author%> (<%= created %>)\n";